/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterPeriodDto } from './FilterPeriodDto';
import {
    FilterPeriodDtoFromJSON,
    FilterPeriodDtoFromJSONTyped,
    FilterPeriodDtoToJSON,
    FilterPeriodDtoToJSONTyped,
} from './FilterPeriodDto';

/**
 * 
 * @export
 * @interface ConnexionListFilters
 */
export interface ConnexionListFilters {
    /**
     * Utilisateur (contient, insensible à la casse)
     * @type {string}
     * @memberof ConnexionListFilters
     */
    userName?: string;
    /**
     * Action exacte du journal (LoginSucceeded, LoginFailed, ImpersonateUser, ChangePassword)
     * @type {string}
     * @memberof ConnexionListFilters
     */
    action?: string;
    /**
     * 
     * @type {FilterPeriodDto}
     * @memberof ConnexionListFilters
     */
    period?: FilterPeriodDto;
}

/**
 * Check if a given object implements the ConnexionListFilters interface.
 */
export function instanceOfConnexionListFilters(value: object): value is ConnexionListFilters {
    return true;
}

export function ConnexionListFiltersFromJSON(json: any): ConnexionListFilters {
    return ConnexionListFiltersFromJSONTyped(json, false);
}

export function ConnexionListFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnexionListFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'userName': json['userName'] == null ? undefined : json['userName'],
        'action': json['action'] == null ? undefined : json['action'],
        'period': json['period'] == null ? undefined : FilterPeriodDtoFromJSON(json['period']),
    };
}

export function ConnexionListFiltersToJSON(json: any): ConnexionListFilters {
    return ConnexionListFiltersToJSONTyped(json, false);
}

export function ConnexionListFiltersToJSONTyped(value?: ConnexionListFilters | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userName': value['userName'],
        'action': value['action'],
        'period': FilterPeriodDtoToJSON(value['period']),
    };
}

